import { useSidebar } from "../../context/SidebarContext";
import HomeIcon from "@mui/icons-material/HomeOutlined";
import WalletOutlinedIcon from "@mui/icons-material/WalletOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import ClassOutlinedIcon from "@mui/icons-material/ClassOutlined";
import ExitToAppIcon from "@mui/icons-material/ExitToAppOutlined";
import AccessTimeIcon from "@mui/icons-material/AccessTimeOutlined";
import GroupIcon from "@mui/icons-material/GroupOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import CenterFocusStrongOutlinedIcon from "@mui/icons-material/CenterFocusStrongOutlined";
import BatchPredictionOutlinedIcon from "@mui/icons-material/BatchPredictionOutlined";
import WorkOutlinedIcon from "@mui/icons-material/HomeRepairServiceOutlined";
import ChildCareOutlinedIcon from "@mui/icons-material/ChildCareOutlined";
import SubjectOutlinedIcon from "@mui/icons-material/SubjectOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ScreenLockLandscapeOutlinedIcon from "@mui/icons-material/ScreenLockLandscapeOutlined";
import InsertChartOutlinedIcon from "@mui/icons-material/InsertChartOutlined";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import { Link, useLocation } from "react-router-dom";
import { useSlug } from "../../SlugContext";
import { useEffect } from "react";
import { useMediaQuery } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import "./sidebar.scss";

const Sidebar = () => {
  const { isSidebarOpen, isCollapsed, closeSidebar, toggleSidebar } =
    useSidebar();
  const { slugs } = useSlug();
  const isMobile = useMediaQuery("(max-width:768px)"); // Check if mobile screen

  // Close sidebar by default on mobile
  useEffect(() => {
    if (isMobile) {
      closeSidebar();
    }
  }, []);

  const linkStrings = {
    "/user": "User-Listing",
    "/coo": "Coo-Listing",
    "/center": "Center-Listing",
    "/account": "Account-Listing",
    "/expense": "Expense-Listing",
    "/batch": "Batch-Listing",
    "/group": "Group-Listing",
    "/class": "Class-Listing",
    "/time-table": "Timetable-Listing",
    "/teacher-attendance": "Teacherattendance-Listing",
    "/Invigilation-attendance": "Invigilationattendance-Listing",
    "/student-attendance": "Studentattendance-Listing",
    "/duty": "Duty-Listing",
    "/student": "Student-Listing",
    "/subject": "Subject-Listing",
    "/teacher": "Teacher-Listing",
    "/role": "Userrole-Listing",
    "/role-screen": "Rolescreen-Listing",
    "/examinations": "Examination-Listing",
    "/monthly-results": "Monthlyresults-Listing",
    "/result-dashboard": "Resultdashboard-Listing",
    "/fees-form": "Feesform-Listing",
    "/ci": "Ci-Listing",
  };

  const isLinkEnabled = (path) => {
    const assignedString = linkStrings[path];
    return slugs.includes(assignedString);
  };

  const location = useLocation();

  const renderMenuItem = (path, icon, label) => {
    if (!isLinkEnabled(path)) return null;

    const isActive = location.pathname === path;

    return (
      <Link
        to={path}
        className="no-underline"
        onClick={() => {
          if (isMobile) closeSidebar();
        }}
      >
        <Tooltip title={isCollapsed ? label : ""} placement="right">
          <li
            className={`flex items-center p-3 py-1 cursor-pointer rounded
            hover:bg-purple-50
            ${isActive ? "bg-purple-100" : ""}
          `}
          >
            {icon}
            {!isCollapsed && (
              <span className="text-[13px] font-semibold text-gray-400 ml-2">
                {label}
              </span>
            )}
          </li>
        </Tooltip>
      </Link>
    );
  };

  return (
    <>
      {/* Mobile Overlay */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black/20 bg-opacity-50 z-40 md:hidden"
          onClick={closeSidebar}
        />
      )}

      {/* Sidebar Container */}
      <div
        className={`fixed md:relative z-40 flex flex-col border-r border-gray-200 h-screen bg-white transition-all duration-300 ease-in-out ${
          isSidebarOpen ? "translate-x-0" : "-translate-x-full md:translate-x-0"
        } ${isCollapsed ? "md:w-20" : "md:w-48"}`}
      >
        {/* Logo Section */}
        <div className="h-12 flex items-center justify-center">
          <Link
            to="/home"
            className="no-underline"
            onClick={() => {
              if (isMobile) {
                closeSidebar();
              }
            }}
          >
            {isCollapsed ? (
              // <span className="text-xl font-bold text-[#7451f8]">CD</span>
              <img
                src={`${process.env.PUBLIC_URL}/logos/EG-Logo-purple-icon.png`}
                alt="Logo"
                className="w-10 h-10 object-contain"
              />
            ) : (
              <div className="flex items-center space-x-2">
                <img
                  src={`${process.env.PUBLIC_URL}/logos/EG-Logo-purple-icon.png`}
                  alt="Logo"
                  className="w-10 h-10 object-contain"
                />
                <span className="text-xl font-bold text-[#7451f8]">
                  Dashboard
                </span>
              </div>
            )}
          </Link>
        </div>

        <hr className="h-px border-0 bg-gray-200" />

        {/* Scrollable Menu Area */}
        <div className="flex-1 overflow-y-auto scrollbar-thin scrollbar-thumb-purple-300">
          <ul className="list-none m-0 p-0">
            {/* MAIN SECTION */}
            {!isCollapsed && (
              <p className="text-xs font-bold text-gray-400 pt-1 pb-1 pl-4 my-4 mb-1">
                MAIN
              </p>
            )}

            <Link
              to="/home"
              className="no-underline"
              onClick={() => {
                if (isMobile) {
                  closeSidebar();
                }
              }}
            >
              <Tooltip title={isCollapsed ? "Home" : ""} placement="right">
                <li
                  className={`flex items-center p-3 py-1 cursor-pointer hover:bg-purple-50 rounded ${
                    location.pathname === "/home" ? "bg-purple-100" : ""
                  }`}
                >
                  <HomeIcon className="text-[13px] p-1 text-[#7451f8]" />
                  {!isCollapsed && (
                    <span className="text-[13px] font-semibold text-gray-400 ml-2">
                      Home
                    </span>
                  )}
                </li>
              </Tooltip>
            </Link>

            {/* LISTS SECTION */}
            {!isCollapsed && (
              <p className="text-xs font-bold text-gray-400 pt-1 pb-1 pl-4 my-4 mb-1">
                LISTS
              </p>
            )}

            {renderMenuItem(
              "/user",
              <PersonOutlineIcon className="text-[18px] text-[#7451f8] p-1" />,
              "Users"
            )}
            {renderMenuItem(
              "/coo",
              <PersonOutlineIcon className="text-[18px] text-[#7451f8] p-1" />,
              "COO"
            )}
            {renderMenuItem(
              "/center",
              <CenterFocusStrongOutlinedIcon className="text-[18px] text-[#7451f8] p-1" />,
              "Centers"
            )}
            {renderMenuItem(
              "/account",
              <AccountCircleOutlinedIcon className="text-[18px] text-[#7451f8] p-1" />,
              "Accounts"
            )}
            {renderMenuItem(
              "/expense",
              <WalletOutlinedIcon className="text-[18px] text-[#7451f8] p-1" />,
              "Expenses"
            )}
            {renderMenuItem(
              "/fees-form",
              <WalletOutlinedIcon className="text-[18px] text-[#7451f8] p-1" />,
              "Receipt"
            )}
            {renderMenuItem(
              "/ci",
              <WalletOutlinedIcon className="text-[18px] text-[#7451f8] p-1" />,
              "Campus Incharge "
            )}

            {renderMenuItem(
              "/batch",
              <BatchPredictionOutlinedIcon className="text-[18px] text-[#7451f8] p-1" />,
              "Batches"
            )}
            {renderMenuItem(
              "/group",
              <GroupIcon className="text-[18px] text-[#7451f8] p-1" />,
              "Groups"
            )}
            {renderMenuItem(
              "/class",
              <ClassOutlinedIcon className="text-[18px] text-[#7451f8] p-1" />,
              "Classes"
            )}
            {renderMenuItem(
              "/time-table",
              <AccessTimeIcon className="text-[18px] text-[#7451f8] p-1" />,
              "Time Table"
            )}
            {renderMenuItem(
              "/teacher-attendance",
              <CheckCircleOutlineIcon className="text-[18px] text-[#7451f8] p-1" />,
              "Teacher Attendance"
            )}
            {renderMenuItem(
              "/Invigilation-attendance",
              <CheckCircleOutlineIcon className="text-[18px] text-[#7451f8] p-1" />,
              "Invigilation Attendance"
            )}
            {renderMenuItem(
              "/student-attendance",
              <CheckCircleOutlineIcon className="text-[18px] text-[#7451f8] p-1" />,
              "Student Attendance"
            )}
            {renderMenuItem(
              "/duty",
              <WorkOutlinedIcon className="text-[18px] text-[#7451f8] p-1" />,
              "Duty"
            )}
            {renderMenuItem(
              "/student",
              <ChildCareOutlinedIcon className="text-[18px] text-[#7451f8] p-1" />,
              "Students"
            )}
            {renderMenuItem(
              "/subject",
              <SubjectOutlinedIcon className="text-[18px] text-[#7451f8] p-1" />,
              "Subjects"
            )}
            {renderMenuItem(
              "/teacher",
              <PersonOutlineIcon className="text-[18px] text-[#7451f8] p-1" />,
              "Teachers"
            )}
            {renderMenuItem(
              "/role",
              <AssignmentIndOutlinedIcon className="text-[18px] text-[#7451f8] p-1" />,
              "User Roles"
            )}
            {renderMenuItem(
              "/role-screen",
              <ScreenLockLandscapeOutlinedIcon className="text-[18px] text-[#7451f8] p-1" />,
              "Role Screens"
            )}
            {renderMenuItem(
              "/examinations",
              <CheckCircleOutlineIcon className="text-[18px] text-[#7451f8] p-1" />,
              "Examination List"
            )}
            {renderMenuItem(
              "/monthly-results",
              <CheckCircleOutlineIcon className="text-[18px] text-[#7451f8] p-1" />,
              "Monthly Results"
            )}
            {!isMobile &&
              renderMenuItem(
                "/result-dashboard",
                <InsertChartOutlinedIcon className="text-[18px] text-[#7451f8] p-1" />,
                "Results Dashboard"
              )}

            {/* ... (rest of your menu items) ... */}

            {/* USER SECTION */}
            {!isCollapsed && (
              <p className="text-xs font-bold text-gray-400 pt-1 pb-1 pl-4 my-4 mb-1">
                USER
              </p>
            )}

            <Link
              to="/profile"
              className="no-underline"
              onClick={() => {
                if (isMobile) {
                  closeSidebar();
                }
              }}
            >
              <Tooltip title={isCollapsed ? "Profile" : ""} placement="right">
                <li
                  className={`flex items-center p-3 py-1 cursor-pointer  hover:bg-purple-50
                    ${location.pathname === "/profile" ? "bg-purple-100" : ""}`}
                >
                  <AccountCircleOutlinedIcon className="text-[18px] text-[#7451f8] p-1" />
                  {!isCollapsed && (
                    <span className="text-[13px] font-semibold text-gray-400 ml-2">
                      Profile
                    </span>
                  )}
                </li>
              </Tooltip>
            </Link>

            <Link
              to="/"
              className="no-underline"
              onClick={() => {
                localStorage.removeItem("token");
                if (isMobile) {
                  closeSidebar();
                }
              }}
            >
              {/* <li className="flex items-center p-3 py-1 cursor-pointer hover:bg-purple-50 rounded">
                <ExitToAppIcon className="text-[18px] text-[#7451f8] p-1" />
                {!isCollapsed && (
                  <span className="text-[13px] font-semibold text-gray-400 ml-2">
                    Logout
                  </span>
                )}
              </li> */}
              <Tooltip title={isCollapsed ? "Logout" : ""} placement="right">
                <li
                  className={`flex items-center p-3 py-1 cursor-pointer rounded hover:bg-purple-50
                    ${location.pathname === "/" ? "bg-purple-100" : ""}`}
                >
                  <ExitToAppIcon className="text-[18px] text-[#7451f8] p-1" />
                  {!isCollapsed && (
                    <span className="text-[13px] font-semibold text-gray-400 ml-2">
                      Logout
                    </span>
                  )}
                </li>
              </Tooltip>
            </Link>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
